module.exports = __webpack_public_path__ + "img/help-solid.342e0bee.svg";